export default "__VITE_ASSET__BQodGKVf__"